import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AccelerateYourVision from "./sections/AccelerateYourVision";
import TheOutputSpectrum from "./sections/TheOutputSpectrum";
import MeasurableMomentum from "./sections/MeasurableMomentum";
import TheForgeWorkflow from "./sections/TheForgeWorkflow";
import PartnerPerspectives from "./sections/PartnerPerspectives";
import StartYourForge from "./sections/StartYourForge";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AccelerateYourVision />
      <TheOutputSpectrum />
      <MeasurableMomentum />
      <TheForgeWorkflow />
      <PartnerPerspectives />
      <StartYourForge />
      <Footer />
    </div>;
}